<div class="plot-content-container">
  <div class="plot-content-buttons">
    <button class="plot-content-button all-data-button-sizing" (click)="allDataClicked()">
      <mat-icon>format_list_bulleted</mat-icon> All data
    </button>
    <button [matMenuTriggerFor]="menu" class="plot-content-button options-button-sizing">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="downloadAsPng()">
        <mat-icon>file_download</mat-icon> <span>Download as PNG</span>
      </button>
      <button mat-menu-item (click)="downloadAsCsv()">
        <mat-icon>download</mat-icon> <span>Download as CSV</span>
      </button>
    </mat-menu>
  </div>
  <div #chartCapture>
    <div class="chart-container chart--pie">
      <plotly-plot [data]="plotlyData.data" [layout]="plotlyData.layout" [config]="plotlyData.config"> </plotly-plot>
      <app-plot-legend [title]="plotLabel" [data]="legendData" [labelOnly]="false" [static]="true"> </app-plot-legend>
    </div>
  </div>
</div>
